import React, { useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import Select from 'react-select';
import { customStyles, the } from './customStyles';

const ScriptDropdown = ({ allScripts, selectedMarket, onScriptChange, value }) => {
    const [scripts, setScripts] = useState([]);
    const [internalSelected, setInternalSelected] = useState(null);

    // Use the controlled `value` prop when provided; otherwise fall back to internal state.
    // This keeps the dropdown display in sync without requiring every parent to pass `value`.
    const selectedScript = value !== undefined ? value : internalSelected;

    useEffect(() => {
        if (selectedMarket) {
            const marketScripts = allScripts[selectedMarket] || {};
            const scriptData = Object.keys(marketScripts).map(category => ({
                label: category,
                value: category
            }));
            setScripts(scriptData);
        } else {
            setScripts([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedMarket, allScripts]);

    // Reset the selected script only when the market actually changes.
    // NOTE: allScripts is intentionally excluded here — BullCache.getFromCache("allScripts")
    // returns a new object reference on every parent render, so depending on it would wipe the
    // selection immediately after the user picks a script.
    useEffect(() => {
        setInternalSelected(null);
    }, [selectedMarket]);

    const handleScriptDropdownChange = (selectedOption) => {
        if (selectedOption) {
            setInternalSelected(selectedOption.value);
            onScriptChange(selectedOption.value);
        } else {
            setInternalSelected(null);
            onScriptChange(null);
        }
    };

    return (
            <Col>
                <Select
                    options={scripts}
                    value={scripts.find(script => script.value === selectedScript) || null}
                    onChange={handleScriptDropdownChange}
                    isMulti={false}
                    theme={the}
                    styles={customStyles}
                    isClearable
                    placeholder="Select"
                />
            </Col>
    );
};

export default ScriptDropdown;
